import { Form, Text, NestedField, Checkbox, Field } from 'react-form';
import Select from 'react-select';
import { isNullOrUndefined } from 'util';
import ReactTooltip from 'react-tooltip'

var UserSelector = require('../General/Selectors/UserSelector').UserSelector;
var SiteSelector = require('../General/Selectors/SiteSelector').SiteSelector;
var ApprovedStocklistSelector = require('../General/Selectors/ApprovedStocklistSelector').ApprovedStocklistSelector;
var TemplateSelector = require('../General/Selectors/TemplateSelector').TemplateSelector;


export class GroupEdit extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isSaved: true,
            errorMessage: "",
            isSaving: false
        }
    }

    setChange(formState, formApi) {

        if (formState.values.limitViewingToApprovedStocklists) {
            formApi.setValue("limitOrderingToApprovedStocklists", true);
        }

        if (formState.values.canManageSites) {
            formApi.setValue("limitSiteView", false);
        }


        this.setState({ isSaved: false });
    }

    sendStateToServer() {
        var self = this;

        fetch(`/api/group/`,
                {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(
                        this.state.submittedValues
                    )
                })
            .then(response => {
                if (!response.ok) {
                    throw {
                        success: false,
                        statusText: "Error with connection."
                    };
                }

                return response.json();
            })
            .then(response => {
                if (response.success === false) {
                    throw response;
                }
                return response;
            })
            .then(response => {
                if (this.props.initialState.id === -1) {
                    window.location = `/groups/${response.groupId}`;
                }

                setTimeout(() => {
                        self.setState({ isSaved: true, errorMessage: "", isSaving:false});
                    },
                    1000); // Add a slight delay so the user can see the saving message
            })
            .catch(response => {
                self.setState({ errorMessage: response.statusText });
            });

    }

    updateDescription(ev) {
        this.setState({
            description: ev.target.value
        });
    }

    submitTemplate(submittedValues) {
        if (submittedValues.approvalRequiredForAllOrders || submittedValues.approvalRequiredForNonStocklists || submittedValues.approvalRequiredForOverBudgetOrders || submittedValues.approvalRequiredForSiteOverBudgetOrders || submittedValues.approvalRequiredForOrderSpend || submittedValues.approvalRequiredForUrgentFastestShipping) {
            if (submittedValues.approvingContactCollection == null || (submittedValues.approvingContactCollection != null && submittedValues.approvingContactCollection.length <= 0)) {
                alert("Approving contact is required for order requiring approval.");

                return;
            }
        } else {
            submittedValues.approvingContactCollection = [];
        }


        if (submittedValues.limitSiteView) {
            if (submittedValues.siteCollection.length <= 0 || submittedValues.siteCollection == null) {
                alert("Please select site on limit site view.");

                return;
            }
        } else {
            submittedValues.siteCollection = [];
        }

        if (!submittedValues.approvalRequiredForSiteOverBudgetOrders) {
            submittedValues.excludeRechargeables = false;
        }        

        this.setState({ submittedValues, isSaving: true }, this.sendStateToServer);
    }

    showErrorMessage() {
        if (this.state.errorMessage != null && this.state.errorMessage.length > 0) {
            return (
                <div className="alert alert-danger" role="alert">
                    {this.state.errorMessage}
                </div>
            );
        }
        return null;
    }

    getUserTitle(formApi) {
        if (formApi.getFormState().values.includesEveryone) {
            return <div className="">
                <div className="everyone"><i className="icon icon-users-group"></i>Everyone</div>
                <div>Except for</div>
            </div>;
        }
    }

    renderSaveButton() {
        var btnText = 'Save';
        var btnClass = 'changes';
        if (this.state.isSaved) {
            btnText = 'Saved';
            btnClass = 'saved';
        }
        if (this.state.isSaving) {
            btnText = 'Saving';
            btnClass = 'saving';
        }

        return <button className={"btn btn-primary float-right " + btnClass} disabled={this.state.isSaved || this.state.isSaving}>{btnText}</button>;
    }

    render() {

        return (
            <div>
                {this.showErrorMessage()}
                <Form
                    onChange={this.setChange.bind(this)}
                    onSubmit={this.submitTemplate.bind(this)} defaultValues={this.props.initialState}>
                    {formApi => {

                        var monthlySpend;
                        if (formApi.getFormState().values.approvalRequiredForSiteOverBudgetOrders) {
                            monthlySpend = (<div className="my-1 mr-sm-2">
                                <div>
                                    <strong> Monthly Spend </strong>
                                </div>
                                <div>
                                    <Text type="number" field="monthlySpend" id="monthly-spend" className="form-control my-1 mr-sm-2 col-sm-3 d-inline" />
                                    <div className="custom-control custom-checkbox my-1 mr-sm-2 d-inline">
                                        <Checkbox field="excludeRechargeables" id="exclude-rechargeables" className="custom-control-input" />
                                        <label className="custom-control-label align-middle" htmlFor="exclude-rechargeables">Exclude Rechargeables</label>
                                    </div>
                                </div>
                            </div>);
                        }

                        var orderSpend;
                        if (formApi.getFormState().values.approvalRequiredForOrderSpend) {
                            orderSpend = (<div className="my-1 mr-sm-2">
                                <div>
                                    <strong>Order Spend</strong>
                                </div>
                                <div>
                                    <Text type="number" field="orderSpend" id="order-spend" className="form-control my-1 mr-sm-2 col-sm-3 d-inline" />
                                    <div className="custom-control custom-checkbox my-1 mr-sm-2 d-inline">
                                        <Checkbox field="excludeRechargeablesOnOrderSpend" id="order-exclude-rechargeables" className="custom-control-input" />
                                        <label className="custom-control-label align-middle" htmlFor="order-exclude-rechargeables">Exclude Rechargeables</label>
                                    </div>
                                </div>
                            </div>);
                        }

                        var approvalContactSection;
                        if (formApi.getFormState().values.approvalRequiredForAllOrders ||
                            formApi.getFormState().values.approvalRequiredForNonStocklists ||
                            formApi.getFormState().values.approvalRequiredForOverBudgetOrders ||
                            formApi.getFormState().values.approvalRequiredForSiteOverBudgetOrders ||
                            formApi.getFormState().values.approvalRequiredForOrderSpend ||
                            formApi.getFormState().values.approvalRequiredForUrgentFastestShipping) {

                            approvalContactSection = (<div>
                                <strong>Approving Contact</strong>
                                <UserSelector field="approvingContactCollection" isMulti />
                            </div>);
                        }

                        

                        var limitSiteViewSection;
                        if (formApi.getFormState().values.limitSiteView) {
                            limitSiteViewSection = (<div>
                                <SiteSelector field="siteCollection" isMulti />
                            </div>);
                        }

                        var poRegex;
                        if (
                            formApi.getFormState().values.purchaseOrderRequiredForAllItems || 
                            formApi.getFormState().values.purchaseOrderRequiredForNonAslItems ||
                            formApi.getFormState().values.purchaseOrderRequiredForNonTemplateItems
                        ) {
                            poRegex = (<div>
                                <div>
                                    <strong>PO Format</strong>
                                </div>
                                <div>
                                    <Text field="purchaseOrderRegex" id="po-regex" className="form-control my-1 mr-sm-2 col-sm-3 d-inline" />
                                </div>
                            </div>);
                        }


                        
                        

                        return (
                            <form onSubmit={formApi.submitForm} id="group-edit-form">
                                <div>
                                    <div className="card card-body bg-light">
                                        <h5>
                                            <label htmlFor="dynamic-template-name">Group name:</label>
                                        </h5>
                                        <Text field="description" id="dynamic-template-name" className="form-control" />
                                        <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                            <Checkbox field="includesEveryone" id="included-everyone" className="custom-control-input" />

                                            <label className="custom-control-label" htmlFor="included-everyone">Include all users</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-lg-6">
                                        <div>
                                        <h5>Users</h5>
                                            {this.getUserTitle(formApi)}
                                            <UserSelector field="memberCollection" isMulti />
                                        </div>

                                        <div>
                                            <h5>Template Edit</h5>
                                            <TemplateSelector field="templateEditCollection" isMulti />
                                        </div>

                                        <div>
                                            <h5>Template View</h5>
                                            <TemplateSelector field="templateViewCollection" isMulti />
                                        </div>

                                        <div>
                                            <h5>Approved Stocklists</h5>
                                            <ApprovedStocklistSelector field="approvedStocklistCollection" isMulti />
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <h5>Permissions</h5>
                                        <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                            <Checkbox field="canManageUsersAndGroups" id="manage-users-group" className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="manage-users-group">Manage Users and Groups</label>
                                        </div>

                                        <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                            <Checkbox field="canViewReports" id="view-reports" className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="view-reports">View Reports</label>
                                        </div>

                                        <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                            <Checkbox field="canViewInvoices" id="view-invoices" className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="view-invoices">View Invoices</label>
                                        </div>

                                        <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                            <Checkbox field="canManageApprovedStocklists" id="manage-approved-stock-lists" className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="manage-approved-stock-lists">Manage Approved Stocklists</label>
                                        </div>
                                       

                                        <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                            <Checkbox field="canEditRechargeableItems" id="can-edit-rechargeable-items" className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="can-edit-rechargeable-items">Allow Overriding Template Rechargeable <i className="icon icon-info" data-tip="This will allow the user to deselect a rechargeable item in the cart, when it is set as rechargeable on a template. A user is always able to select an item as rechargeable regardless of this setting."></i> <ReactTooltip /></label>
                                        </div>

                                        <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                            <Checkbox field="hidePrices" id="hide-prices" className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="hide-prices">Hide Prices</label>
                                        </div>

                                        <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                            <Checkbox field="canViewEquipment" id="view-equipment" className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="view-equipment">View Equipment</label>
                                        </div>

                                        <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                            <Checkbox field="disableOnlineOrdering" id="disable-online-ordering" className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="disable-online-ordering">Disable Online Ordering</label>
                                        </div>

                                        <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                            <Checkbox field="disableTemplateCreation" id="disable-template-creation" className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="disable-template-creation">Disable Template Creation</label>
                                        </div>

                                        <h5>Approvals</h5>
                                        <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                            <Checkbox field="approvalRequiredForAllOrders" id="approval-all-orders" className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="approval-all-orders">Requires approval for all orders</label>
                                        </div>
                                        <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                            <Checkbox field="approvalRequiredForNonStocklists" id="approval-non-stocklists" className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="approval-non-stocklists">Requires approval for non stocklist items</label>
                                        </div>
                                        <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                            <Checkbox field="approvalRequiredForOverBudgetOrders" id="approval-over-budget-orders" className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="approval-over-budget-orders">Requires approval for over budget orders</label>
                                        </div>
                                        <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                            <Checkbox field="approvalRequiredForOrderSpend" id="approval-order-spend" className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="approval-order-spend">Requires approval for order spend <i className="icon icon-info" data-tip="When the total of the order spend is over the specified amount."></i> <ReactTooltip />
                                            </label>
                                        </div>
                                        {orderSpend}

                                        <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                            <Checkbox field="approvalRequiredForSiteOverBudgetOrders" id="approval-monthly-spend" className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="approval-monthly-spend">Requires approval for site supervisor monthly spend <i className="icon icon-info" data-tip="When the total of the monthly spend for sites managed by a site supervisor are over the specified amount."></i> <ReactTooltip />
                                            </label>
                                        </div>
                                        {monthlySpend}

                                        <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                            <Checkbox field="approvalRequiredSiteAuthMember" id="approval-site-auth-member" className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="approval-site-auth-member">Requires site auth approval <i className="icon icon-info" data-tip="User permission values can be setup on the site."></i></label>
                                        </div>

                                        <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                            <Checkbox field="approvalRequiredForUrgentFastestShipping" id="approval-required-urgent-fastest" className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="approval-required-urgent-fastest">Requires approval for urgent/fastest shipping</label>
                                        </div>

                                        {approvalContactSection}

                                        <h5>Purchase Order</h5>
                                        <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                            <Checkbox field="purchaseOrderRequiredForAllItems" id="purchase-order-all" className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="purchase-order-all">Requires purchase order for all orders</label>
                                        </div>
                                        <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                            <Checkbox field="purchaseOrderRequiredForNonAslItems" id="purchase-order-non-asl" className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="purchase-order-non-asl">Requires purchase order for non stocklist items</label>
                                        </div>
                                        <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                            <Checkbox field="purchaseOrderRequiredForNonTemplateItems" id="purchase-order-non-template" className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="purchase-order-non-template">Requires purchase order for non template items</label>
                                        </div>
                                        {poRegex}

                                        <h5> Sites </h5>
                                        <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                            <Checkbox field="canManageSites" id="manage-sites" className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="manage-sites">Manage Sites</label>
                                        </div>

                                        <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                            <Checkbox field="canManageBudgetForAllBudgets" id="manage-site-budget-for-all-budgets" disabled={formApi.getFormState().values.hideSiteBudget} className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="manage-site-budget-for-all-budgets">Manage Budgets for all sites</label>
                                        </div>

                                        <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                            <Checkbox field="hideSiteBudget" id="hide-site-budget" disabled={formApi.getFormState().values.canManageBudgetForAllBudgets} className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="hide-site-budget">Hide Site Budget</label>
                                        </div>

                                        <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                            <Checkbox field="limitSiteView" id="limit-site-view" disabled={formApi.getFormState().values.canManageSites} className="custom-control-input"  />
                                            <label className="custom-control-label" htmlFor="limit-site-view">Limit Site View</label>
                                        </div>
                                        {limitSiteViewSection}

                                        <h5> Ordering </h5>

                                        <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                            <Checkbox field="limitViewingToApprovedStocklists" id="limit-viewing-to-approved-stocklists" className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="limit-viewing-to-approved-stocklists">Limit Viewing to Approved Stocklists</label>
                                        </div>

                                        <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                            <Checkbox field="limitOrderingToApprovedStocklists" disabled={formApi.getFormState().values.limitViewingToApprovedStocklists} id="limit-ordering-to-approved-stocklists" className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="limit-ordering-to-approved-stocklists">Limit Ordering to Approved Stocklists</label>
                                        </div>

                                        <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                            <Checkbox field="limitOrderingToTemplate" id="limit-ordering-to-template" className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="limit-ordering-to-template">Limit Ordering to Templates</label>
                                        </div>

                                        <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                            <Checkbox field="canCreateRecurringOrders" id="can-create-recurring-orders" className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="can-create-recurring-orders">Can Create Recurring Orders <i className="icon icon-info" data-tip="Recurring orders can be set up on a site."></i> </label>
                                        </div>

                                        <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                            <Checkbox field="siteRequiredForAllOrders" id="site-required-for-all-orders" className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="site-required-for-all-orders">Site Required For All Orders</label>
                                        </div>

                                        <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                            <Checkbox field="disableItemReplacement" id="disable-item-replacement" className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="disable-item-replacement">Disable Item Replacement</label>
                                        </div>

                                        <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                            <Checkbox field="defaultMultipleDeliveries" id="default-multiple-deliveries" className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="default-multiple-deliveries">Default Multiple Deliveries <i className="icon icon-info" data-tip="If checked the default will be for multiple deliveries to be used, please note extra charges may apply"></i> </label>
                                        </div>
                                    </div>
                                </div>
                                <a href="/groups" className="btn btn-outline-primary">View all groups</a>
                                {this.renderSaveButton()}
                            </form>
                        )
                    }}
                </Form>
            </div>
        );
    }

}